export default "__VITE_ASSET__ByWx$V$R__"